export class OnlineResolutionsDeleteRequest {
  resolutionId!: string

  constructor(resolutionId: string) {
    this.resolutionId = resolutionId
  }
}
